import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'alg-autoricarica-codici-forniture',
  templateUrl: './alg-autoricarica-codici-forniture.component.html',
  styleUrls: ['./alg-autoricarica-codici-forniture.component.scss']
})
export class AlgAutoricaricaCodiciFornitureComponent implements OnInit {
  @Input() isActivationRequest: boolean;
  @Input() clientInfo: any;
  @Input() supplyCommodities: any;
  @Input() listTypeSupply: any;
  @Input() supplyGas: any;
  @Input() supplyLight: any;
  
  public activationField = {
    label1: 'contraddistinto per:',
    label2: '- Codice di fornitura energia elettrica',
    label3: '- Codice di fornitura gas naturale',
    label4:
      'l\'attivazione della specifica premialità dello "Sconto automatico in bolletta", relativamente alla/e fornitura/e sopra indicata/e secondo i termini e le condizioni di cui al regolamento che disciplina l\'iniziativa "Catalogo Soci - Raccolta punti“, disponibile presso i punti vendita di Coop Alleanza 3.0. (quale soggetto promotore) oppure nel sito web https://www.coopalleanza3-0.it/',
    label5: 'Il sottoscritto dichiara:',
    label6:
      'Ogni interessato deve sapere che la versione integrale dell’informativa privacy relativa al Catalogo Soci - Raccolta punti - Collazionamento a premi per l’anno in corso è disponibile insieme al contenuto del Regolamento Raccolta punti.',
    label7:
      'Questa informativa ha come destinatari tutti i soci titolari della Carta SocioCoop e che in fase di fruizione punti i dati personali richiesti (indicati nel modulo) sono trattati dal Titolare al trattamento dei dati in qualità di soggetto promotore quale è COOP ALLEANZA 3.0 S. C., per consentire la verifica dei punti accumulati, anche presso gli altri Titolari in qualità di soggetti associati alla raccolta punti per l’anno corrente allo scopo di autorizzare l’utilizzo ed il ritiro del/i premio/i presenti in catalogo; sono previste comunicazioni dei dati personali per assicurare tra i vari Titolari del trattamento il rispetto del regolamento al fine di consentire le modalità di godimento dei premi',
  };

  constructor() { }

  

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-autoricarica-codici-forniture/alg-autoricarica-codici-forniture.component.ts